import ErrorAlert from "components/Alerts/error";
import SuccessAlert from "components/Alerts/succes";
import React, { useState } from "react";
import { ConfirmServiceOrder } from "services/orders.service";

const OrderConfirmation = ({
  activeOrder,
  getOrdersList,
  getOrderById,

  Status,
}) => {
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  let getPendingStatus = activeOrder?.status === "Accept" && Status;
  const handleConfirmOrder = OrderId => {
    let DateandTime = new Date();
    const formattedDateTime = DateandTime.toISOString();
    let body = {
      orderConfirmedByStylist: true,
      orderConfirmedByStylistDateTime: formattedDateTime,
    };
    ConfirmServiceOrder(OrderId, body)
      .then(res => {
        if (res?.data) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
      })
      .catch(err => {
        seterror_msg(true);
      });
  };
  const leaveToList = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    getOrdersList();
    getOrderById(activeOrder);
  };

  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    getOrdersList();
    getOrderById(activeOrder);
  };
  return (
    <>
      <div className="">
        <div className="bg-light p-1">
          <p className="mb-0">Order Status</p>
        </div>
        <button
          className={`btn btn-sm my-3 px-3 py-2 font-size-16  ${
            getPendingStatus ? "btn-primary-red" : "btn-success"
          }`}
          onClick={() => {
            handleConfirmOrder(activeOrder?._id);
          }}
          // disabled={getPendingStatus ? false : true}
        >
          {getPendingStatus ? "Confirm Order" : "Order Confirmed"}
        </button>
      </div>
      {success_msg ? (
        <SuccessAlert
          msg={`Order (#${activeOrder?.orderId}) is confirmed successfully`}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
      {error_msg ? (
        <ErrorAlert
          msg={"error"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
    </>
  );
};

export default OrderConfirmation;
